const PREFIX = process.env.VUE_APP_API;

export default {
  // apply
  applySchool: `${PREFIX}/api/common/apply/school`,
  applyCompany: `${PREFIX}/api/common/apply/company`,

  // smslogin
  smsSend: `${PREFIX}/api/www/account/sms`,
  smsLogin: `${PREFIX}/api/www/account/login`,
  accountList: `${PREFIX}/api/www/account/account-list`,

  // common
  cityData: `${PREFIX}/api/common/cities`,
  formData: `${PREFIX}/api/common/apply/company/form-data`,

  schoolInvite: (code: string) => `${PREFIX}/api/www/school/${code}/invite`,
  // qiniu
  qiniuUrl: "https://upload.qiniup.com",
  qiniuConfig: `${PREFIX}/api/file/config`,
  qiniuToken: `${PREFIX}/api/file/qiniu-upload-token`,
  qiniuStore: `${PREFIX}/api/file/qiniu-file-store`,
  //试用申请
  trialInfo: `${PREFIX}/api/www/trail-apply`,
};
